import { Link } from 'react-router-dom';
import { cn } from './cn';

type Props = { to: string; image?: string; type: string; title: string; meta?: string; className?: string };

/**
 * Carte d'actualité: image, type, titre, puis « lieu | date ».
 * Au survol la carte glisse de 0,7 rem; l'image reçoit un cadre orange décalé fermé par deux petits triangles.
 */
export default function StoryCard({ to, image, type, title, meta, className }: Props) {
  return (
    <Link to={to} className={cn('story-card group block transition-transform duration-100 ease-in-out hover:translate-x-[0.7rem]', className)}>
      <div className="story-img relative aspect-[16/9] bg-secondary-200">
        {image && <img src={image} alt="" loading="lazy" className="h-full w-full object-cover" />}
      </div>
      <div className="pt-5">
        <div className="text-xs font-semibold uppercase tracking-[0.0625rem] text-ink">{type}</div>
        <h3 className="mt-2 text-inherit font-sans text-[1.125rem] font-semibold normal-case leading-[1.5] tracking-normal text-black group-hover:text-brand-dark group-hover:underline md:text-[1.1875rem]">{title}</h3>
        {meta && <p className="mt-3 text-sm text-black">{meta}</p>}
      </div>
    </Link>
  );
}
